(function () {
    'use strict';

    /*global angular*/
    var app = angular.module('cccu.photoUpload.upload',
        [
            'ui.router',
            'ngImgCrop',
            'cccu.photoUpload.services'
        ]
        );

    app.config(function ($stateProvider) {
        $stateProvider.state('upload', {
            url: '/upload',
            views: {
                'main': {
                    controller: 'UploadController',
                    templateUrl: 'upload/index.html'
                }
            },
            data: {
                pageTitle: 'Upload your photo'
            }
        });
    });

    app.controller('UploadController', ['$scope', '$location', '$log', '$window', 'photoUploadService', function ($scope, $location, $log, $window, photoUploadService) {

        $scope.imageOK = false;
        $scope.loading = false;
        //$scope.size = 'small';
        $scope.type = 'square';
        $scope.aspectRatio = '35x45';
        $scope.image = {
            originalInfo: {},
            cropInfo: {}
        };
        $scope.myCroppedImage = '';
        $scope.imageDataURI = '';
        $scope.resImageDataURI = '';
        $scope.resImgFormat = 'image/png';
        $scope.resImgQuality = 1;
        $scope.selMinSize = 100;
        $scope.resImgSize = 200;
        //$scope.aspectRatio=1.2;
        $scope.onChange = function ($dataURI) {
            console.log('onChange fired');
        };
        $scope.onLoadBegin = function () {
            console.log('onLoadBegin fired');
        };
        // this event is fired when an image is successfully uploaded.
        $scope.onLoadDone = function () {
            console.log('onLoadDone fired');
            $scope.imageOK = true;
            $scope.loading = false;
        };
        $scope.onLoadError = function () {
            console.log('onLoadError fired');
            $scope.imageOK = false;
            $scope.error = 'Please make sure you upload a valid image.';
            $scope.loading = false;
        };
        var handleFileSelect = function (evt) {
            var file = evt.currentTarget.files[0];
            if (file) {

                console.log('handleFileSelect fired');
                $scope.imageOK = false;
                $scope.error = '';
                $scope.loading = true;

                var reader = new FileReader();
                reader.onload = function (evt) {
                    $scope.$apply(function ($scope) {
                        $scope.imageDataURI = evt.target.result;
                    });
                };
                reader.readAsDataURL(file);
            }
        };
        angular.element(document.querySelector('#fileInput')).on('change', handleFileSelect);
        $scope.$watch('resImageDataURI', function () {
            //console.log('Res image', $scope.resImageDataURI);
        });

        // page events
        $scope.resetImage = function () {

            $scope.imageDataURI = '';
            $scope.myCroppedImage = '';
            $scope.imageOK = false;
            $scope.error = '';
            $scope.loading = false;

            // shouldn't be doing this in the controller.
            angular.forEach(
                angular.element("input[type='file']"),
                function (inputElem) {
                    angular.element(inputElem).val(null);
                });
        };
        $scope.next = function () {
            photoUploadService.photo = $scope.myCroppedImage;
            $location.path('/preview');
        };

        $scope.back = function () {
            $location.path('/instructions');
        };
    }]);
}());